export default class WebFwf {
  fwf = null;

  context = {};
  features = {};
  observers = new Set();

  constructor() {}

  async getFlag(key) {
    return {
      isEnabled: false,
      isAbTest: false,
      keyName: key,
      variation: null,
    };
  }

  setContext() {}

  trackFeature() {}

  subscribeFeatures() {}

  unsubscribeFeatures() {}

  subscribeObserver() {}

  unsubscribeObserver() {}
}
